module.exports = __webpack_public_path__ + "img/icon-MeetingDetails-gray.54f8da50.png";